/**
 * survey-api subscription display labels.
 *
 * The plan catalog itself (tiers, limits, prices) is fetched from
 * `GET /api/v1/plans` (see modules/Subscription/actions.js fetchPlans) —
 * nothing is hardcoded here anymore. Only the human-readable labels for the
 * usage feature keys returned by `GET /subscriptions/usage` live in this file.
 */

export const FEATURE_LABELS = {
  // keys returned by GET /subscriptions/usage
  FORMS: 'Forms',
  RESPONSES: 'Responses',
  STORAGE_MB: 'Storage (MB)',
  // keys returned by 429 quota errors (check-usage-limit middleware)
  FORM: 'Forms',
  RESPONSE: 'Responses',
  STORAGE: 'Storage',
};
